import { zApplicationSessionRefreshOut } from "@/api-client/zod.gen";

import type { TokenResponse } from "./session-store";

export const SESSION_REFRESH_PATH = "/api/v1/auth/session/refresh/";
export const SESSION_LOGOUT_PATH = "/api/v1/auth/session/logout/";

// The OpenAPI schema declares no request body for the auth POST endpoints, so the
// generated SDK cannot send the JSON body the backend requires.
export function postAuthJson(path: string, body: Record<string, unknown> = {}): Promise<Response> {
  return fetch(path, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(body),
    credentials: "same-origin",
    cache: "no-store",
  });
}

export async function readTokenResponse(response: Response): Promise<TokenResponse | null> {
  try {
    const parsed = zApplicationSessionRefreshOut.safeParse(await response.json());
    return parsed.success ? parsed.data : null;
  } catch {
    return null;
  }
}

export async function readAuthErrorCode(response: Response): Promise<string | null> {
  try {
    const body: unknown = await response.json();
    if (typeof body === "object" && body !== null && "code" in body) {
      return typeof body.code === "string" ? body.code : null;
    }
    return null;
  } catch {
    return null;
  }
}

export function readRetryAfterSeconds(response: Response): number | null {
  const header = response.headers.get("Retry-After");
  if (header === null || header.trim() === "") {
    return null;
  }
  const seconds = Number(header);
  return Number.isFinite(seconds) && seconds >= 0 ? Math.ceil(seconds) : null;
}
